export default "__VITE_ASSET__CSa25FnZ__"